import { Incident, Message } from "@/types/incidents";
import { ApiResponse } from "@/types/api";
import api from "../api";

export const incidentsApi = {
  getAll: async (signal?: AbortSignal, locationID?:string): Promise<ApiResponse<Incident>> => {
    try {
     
      const query = locationID ? `?locationID=${locationID}` : "";
      const { data } = await api.get(`/incidents/active${query}`, {
        signal,
      });
      
      return data;
    } catch (error:any) {
      console.error("Failed to fetch Incident:", error);
      return error;
    }
  },
  getActiveIncidentsCount: async (signal?: AbortSignal): Promise<number> => {
    const { data } = await api.get("/incidents/active/count", {
      signal,
    });
    return data.data.count;
  },
  sendMessage: async (incidentID: number, message: string) => {
    try {
      const response = await api.post(`/incidents/${incidentID}/messages`, {
        message,
        messageTime: new Date().toISOString(),
      });
      return response.data;
    } catch (error) {
      console.error("Failed to send message:", error);
      throw error;
    }
  },
  getMessages: async (
    incidentID: number,
    offset: number = 0,
    limit: number = 20
  ): Promise<ApiResponse<Message[]>> => {
    const { data } = await api.get(`/incidents/${incidentID}/messages`, {
      params: { offset, limit },
    });

    return {
      ...data,
      data: data.data.flat(),
    };
  },
  updateIncident: async (
    incidentID: number,
    data: {
      resolveStatus: string;
      userLocation?: string;
      situation?: string;
    }
  ) => {
    const response = await api.put(`/incidents/${incidentID}/resolve`, data);
    return response.data;
  },
  updateIncidentSituation: async (incidentID: number, situation: string) => {
    const response = await api.put(`/incidents/${incidentID}`, {
      situation,
    });
    return response.data;
  },
  assignResponders: async (incidentID: number, dispatcherIDs: number[],groupId:string) => {
    try {
      const url =groupId ?`/group/${groupId}/assign-dispatcher` : `/incidents/${incidentID}/assign-dispatcher`

      const response = await api.put(
      url ,
        {
          dispatcherIDs,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Failed to assign responders:", error);
      throw error;
    }
  },
  resolveGroup: async (groupId: string): Promise<void> => {
    try {
      await api.put(`/incidents/group/${groupId}/resolve`);
    } catch (error) {
      console.error("Failed to resolve group:", error);
      throw error;
    }
  },
  getLocationHistory:async(incidentID:number): Promise<any> => {
    try {
    const response=  await api.get(`/incidents/${incidentID}/location-history`);
    return response.data;
    } catch (error) {
      console.error("Failed to resolve group:", error);
      throw error;
    }
  },
  getLocationAddress:async(latLong:{lat:number,lng:number}): Promise<any> => {
    try {
      const response=  await api.post(`/geo/reverse-geocode`,latLong);
      return response.data;
      } catch (error) {
        console.error("Failed to resolve group:", error);
        throw error;
      }
  }
};
